import { Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react';
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate';
import Chart from './chartImc';
import { UtilsTable } from '../../../../app/orussystem/utils/UtilTable';
import ChartPeso from './chartImcPeso';
import { GraficasStyles } from '../GraficasStyles';

const CardPeso = ({ rows, isLoad, paperStyle, lIcms, peso }) => {
  const classes = GraficasStyles();

  return (
    <Paper>
      <Typography className={classes.title} color='primary'>Peso y masa corporal</Typography>

      <Grid container spacing={2}>
        {/* Columna para Chart */}
        <Grid item xs={12} lg={4}>
          <Paper className={paperStyle}>
            <Chart data={lIcms} />
          </Paper>
        </Grid>

        {/* Columna para Card */}
        <Grid item xs={12} lg={4}>
          <Paper className={paperStyle}>
            {/* Contenido de la Card */}
            <Table size="small" style={{ marginTop: "20px" }}>
              <TableHead>
                <TableRow alignItems="center">
                  <TableCell align="center">Fecha</TableCell>
                  <TableCell align="center">Imc</TableCell>
                  <TableCell align="center">Peso</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoad ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">Cargando...</TableCell>
                  </TableRow>
                ) : (
                  rows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{UtilsTable().validateRowsTable(UtilsDate().formatDDMMMYYYY(new Date(row.datecreate)))}</TableCell>
                      <TableCell align="center">{UtilsTable().validateRowsTable(row.imc)}</TableCell>
                      <TableCell align="center">{UtilsTable().validateRowsTable(row.peso)}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Paper>
        </Grid>

        {/* Columna para ChartPeso */}
        <Grid item xs={12} lg={4}>
          <Paper className={paperStyle}>
            <ChartPeso data={peso} data1={lIcms} />
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default CardPeso;
